import packageInfo from '../../package.json';

export const environment = {
  production: true,
  name: packageInfo.name,
  environment: 'production',
  apiRoute: 'https://journal-server.stemtaught.com',
  sentry: {
    DSN: 'https://88480cff23c64818b98a6c2ba0be5c02@o4505473693384704.ingest.sentry.io/4505473702756352',
    autoSessionTracking: true,
    enabled: true,
    dialogEnabled: false,
  },
  version: packageInfo.version,
};
